import styled from "styled-components";
import Img from "../../Img";

export const Wrapper = styled.div`
  display: flex;
  width: 24px;
  height: 24px;
  cursor: pointer;
  @media (max-width: 1366px) {
    width: 20px;
    height: 20px;
  }
`;

export const Image = styled(Img)`
  display: flex;
  width: 100%;
  height: 100%;
`;
